import { createAtlasServiceLazy } from '@wix/form-fields';
import React, { useMemo } from 'react';
import { FormViewerStatic } from '../../components/root/form-viewer-static';
import { useFormActions } from '../../hooks/use-form-actions';
import { getForm } from '../controller-props';
import FormLoadingError from './form-loading-error/form-loading-error';
import Providers from './providers';
import { useSimulateError } from './use-simulate-error';
const Widget = ({ forwardedRef, controller, i18n, formId, values, stepId, onChange, onBlur, onFocus, onStepIdChange, errors, onValidate, onError, externalData, overrides, bi, biFormFillSessionId, forcedState, fields, RicosViewer, panorama, onSubmit, onSubmitSuccess, onSubmitFailure, onStatusChange, PortalContainer })=>{
    const { wfActions, wfConfig, wfResults } = controller;
    if (!wfActions || !wfConfig || !wfResults) {
        throw new Error('Missing controller props');
    }
    useSimulateError(wfConfig);
    const form = getForm(wfConfig, formId);
    const { formActions, inProgress } = useFormActions({
        wfActions,
        wfResults
    });
    const { instance, language, atlasBaseUrl } = wfConfig;
    const addressActions = useMemo(()=>createAtlasServiceLazy({
            getInstance: ()=>instance ?? '',
            language,
            atlasBaseUrl
        }), [
        instance,
        language,
        atlasBaseUrl
    ]);
    return /*#__PURE__*/ React.createElement(Providers, {
        config: wfConfig
    }, form ? /*#__PURE__*/ React.createElement(FormViewerStatic, {
        ref: forwardedRef,
        actions: {
            ...formActions,
            ...addressActions
        },
        form: form,
        language: wfConfig.language,
        regionalFormat: wfConfig.regionalFormat,
        isEditor: wfConfig.isEditor,
        isComposer: wfConfig.isComposer,
        addressTemplates: wfConfig.addressTemplates,
        userData: wfConfig.userData,
        visitorId: wfConfig.visitorId,
        compId: wfConfig.compId,
        baseUrl: wfConfig.baseUrl,
        enableAutofill: !wfConfig.isEditor && !wfConfig.isComposer,
        values: values,
        stepId: stepId,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onStepIdChange: onStepIdChange,
        errors: errors,
        onValidate: onValidate,
        onSubmit: onSubmit,
        onSubmitSuccess: onSubmitSuccess,
        onSubmitFailure: onSubmitFailure,
        onStatusChange: onStatusChange,
        isMobile: wfConfig.isMobile,
        isRTL: wfConfig.isRTL,
        i18n: i18n,
        bi: bi,
        biFormFillSessionId: biFormFillSessionId,
        externalData: externalData,
        translations: wfConfig.translations,
        localeDataset: wfConfig.localeDataset,
        overrides: overrides,
        forcedState: forcedState,
        inProgress: inProgress,
        experiments: wfConfig.experiments,
        currency: wfConfig.currency,
        fields: fields,
        RicosViewer: RicosViewer,
        fieldInitialData: wfConfig.fieldInitialData,
        panorama: panorama,
        PortalContainer: PortalContainer
    }) : /*#__PURE__*/ React.createElement(FormLoadingError, {
        formId: formId,
        i18n: i18n,
        translations: wfConfig.translations,
        language: wfConfig.language,
        onError: onError,
        isRTL: wfConfig.isRTL
    }));
};
export default Widget;

//# sourceMappingURL=widget.js.map